<template>
  <!-- 练习中心考试练习模式 -->
  <div class="uni-startPractice">
    <div class="leftBox" id="leftBox" @scroll="getScrollTop">
      <i class="iconfont iconfanhui" @click="$router.go(-1)"></i>
      <div class="title f24">{{ specialtyName }}</div>
      <div :class="fontClass">
        <!-- 填空题 -->
        <FillBlank
          v-if="currentQuestion.questionType === '填空题样式'"
          ref="topicRef"
          :index="currentIndex"
          :datas="currentQuestion"
          :isAnalysis="isAnalysis"
          @showAnalysis="showAnalysis = !showAnalysis"
        />
        <!-- 单选题 -->
        <ChoiceOne
          ref="topicRef"
          v-if="currentQuestion.questionType === '单选题样式'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isAnalysis="isAnalysis"
          @next="next"
          @showAnalysis="showAnalysis = !showAnalysis"
        />
        <!-- 多选题 -->
        <ChoiceMultiple
          ref="topicRef"
          v-if="currentQuestion.questionType === '多选题样式'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isAnalysis="isAnalysis"
          @showAnalysis="showAnalysis = !showAnalysis"
        />
        <!-- 判断题 -->
        <Judge
          ref="topicRef"
          v-if="currentQuestion.questionType === '判断题样式'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isAnalysis="isAnalysis"
          @next="next"
          @showAnalysis="showAnalysis = !showAnalysis"
        />
        <!-- 简答题 -->
        <Subjective
          ref="topicRef"
          v-if="currentQuestion.questionType === '简答题样式'"
          :index="currentIndex"
          :datas="currentQuestion"
          :isAnalysis="isAnalysis"
          @showAnalysis="showAnalysis = !showAnalysis"
        />
        <QuestionAsk
          ref="topicRef"
          v-if="currentQuestion.questionType === '一题多问样式'"
          :isAnalysis="isAnalysis"
          :index="currentIndex"
          :scrollTop="scrollTop"
          :datas="currentQuestion"
          @viewScroll="viewScroll"
        />
        <div
          class="submit mat20"
          v-if="
            currentIndex !== datas.topicList.length &&
            !['单选题样式', '判断题样式'].includes(currentQuestion.questionType)
          "
        >
          <div @click="next(false)">下一题</div>
        </div>
        <!-- 解析 -->
        <QuestionAnalysis
          ref="questionAnalysis"
          v-show="showAnalysis"
          :analysisDatas="currentQuestion"
          @collectChange="updateCollect"
        />
      </div>
    </div>

    <div class="mat20">
      <AnswerSheet
        :isAnalysis="false"
        :datas="answerSheetGroupDTOS"
        :currentId="currentQuestionId"
        :total="totalSum"
        @change="jumpTo"
        @submit="submit"
        @isEmpty="isEmpty"
        @handleScroll="handleScroll"
      />
    </div>
    <!-- 提示框 -->
    <ComponentDialog1
      :icon="scoreDialog.icon"
      :title="scoreDialog.title"
      :score="scoreDialog.score"
      :visible.sync="isScoreVisible"
      iconPosition="left-top"
      @confirm="scoreConfirm"
      :showCancelBtn="scoreDialog.showCancelBtn"
      confirmText="查看解析"
    />
  </div>
</template>

<script>
import AnswerSheet from "@/components/answerSheet";
import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";
import QuestionAnalysis from "@/views/business/questionType/questionAnalysis";
import QuestionAsk from "@/views/business/questionType/questionAsk";
import { topicTitle, topicNext, topicSubmit } from "@/api/practice";
import { mapState } from "vuex";

export default {
  name: "uni-startPractice",
  computed: {
    ...mapState("common", {
      fontClass: (state) => state.fontClass,
    }),
  },
  components: {
    AnswerSheet, //工具栏
    QuestionAnalysis, //解析
    ChoiceOne, //单选
    FillBlank, //填空
    Judge, //判断
    ChoiceMultiple, //多选
    Subjective, //简答
    QuestionAsk,
  },
  watch: {},
  data() {
    return {
      showAnalysis: false,
      isAnalysis: true,
      // 路由参数
      paperUuid: "", //试卷id
      examUuid: "", //考试id
      // 分数弹框
      isScoreVisible: false,
      scoreDialog: {
        title: "",
        score: 0,
        icon: "",
        showCancelBtn: false,
      },
      // 题目集合
      datas: {
        topicList: [],
      },
      answerSheetGroupDTOS: [],
      currentQuestionId: "",
      totalSum: 0,
      // 当前题目
      specialtyName: "",
      currentQuestion: {}, //题目
      currentIndex: 1, //索引
      scrollTop: 0
    };
  },
  // 挂载结束状态
  mounted() {
    this.paperUuid = this.$route.query.paperUuid;
    this.examUuid = this.$route.query.examUuid;
    // this.getExamName();
    this.getAnalysisDetail().then(() => {
      // 初始化第一道题
      if (this.datas.topicList && this.datas.topicList.length > 0) {
        this.resetCurrent(0);
      }
    });
  },
  methods: {
    handleScroll(index) {
      if(this.currentQuestion.questionType === '一题多问样式') {
        this.$refs['topicRef'].onScroll(index, this.currentQuestion);
      }
    },
    getScrollTop(val) {
      this.scrollTop = val.target.scrollTop;
      // console.log(this.scrollTop)
    },
    viewScroll(top) {
      let scrollDom = document.getElementById('leftBox');
      scrollDom.scrollTo({
        top: top,
        behavior: "smooth"
      });
    },
    /**
     * 练习题请求
     */
    async getAnalysisDetail() {
      const params = {
        relationId: this.paperUuid,
        isDone: true,
        isShowDetail: false,
        topicType: this.$route.query.title,
      };
      const datas = await topicTitle(params);
      if (datas) {
        datas.topicList = datas.doTopicDTOS.map((item) => {
          if (item.questionType === "单选题样式" || item.questionType === "多选题样式" || item.questionType === "判断题样式") {
            item.studentAnswerList = item.studentAnswerList.map((item2) => {
              return JSON.stringify(item2);
            });
          } else {
            item.studentAnswerList = item.studentAnswerList.length > 0 ? item.studentAnswerList : item.answerList;
          }
          return item;
        });
        this.specialtyName = datas.otherInfoDTO.titles[0];
        this.answerSheetGroupDTOS = datas.answerSheetGroupDTOS;
        this.datas = datas;
        datas.otherInfoDTO.topicTypeNums.forEach((val) => [
          (this.totalSum += val.questionNumber),
        ]);
      }
    },
    /**
     * 重置当前题目
     * currentIndex: 当前题的索引
     */
    resetCurrent(currentIndex, topicNum, id) {
      const than = this;
      this.currentQuestion = this.datas.topicList[currentIndex];
      if (this.currentQuestion.questionType !== "一题多问样式") {
        this.currentQuestionId = this.currentQuestion.id;
      } else {
        setTimeout(() => {
          than.$refs["topicRef"].getTitleInformation(than.currentQuestion);
        }, 100);
        if (topicNum) {
          this.currentQuestion.doTopicDTOS.forEach((val) => {
            if (val.topicNum === topicNum) {
              this.currentQuestionId = val.id;
            }
          });
        } else {
          this.currentQuestionId = this.currentQuestion.doTopicDTOS[0].id;
        }
      }
      this.currentIndex = currentIndex + 1;
      if(id) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.handleScroll(id);
          }, 100)
        })
      }
    },
    isEmpty() {
      this.$refs.questionAnalysis.emptyData();
    },
    /**
     * 下一题
     */
    async next() {
      this.showAnalysis = false;
      this.isEmpty();
      if (this.currentIndex === this.datas.topicList.length) return;
      await this.putSaveAnswer();
      this.answerChange();
      this.resetCurrent(this.currentIndex);
      this.viewScroll(0);
    },
    async putSaveAnswer() {
      const currentQuestion = this.currentQuestion;
      let params = {};
      if (currentQuestion.questionType === "一题多问样式") {
        let currentAnswer = [];
        this.$refs["topicRef"].datas.doTopicDTOS.map((val) => {
          let answer = [];
          if (
            val.studentAnswerList.length > 0 &&
            val.questionType !== "填空题样式" &&
            val.questionType !== "简答题样式"
          ) {
            val.studentAnswerList.map((valTo) => {
              typeof valTo === "object"
                ? answer.push(valTo)
                : answer.push(JSON.parse(valTo));
            });
          } else {
            val.studentAnswerList.map((valTo) => {
              if (valTo.name) {
                typeof valTo === "object"
                  ? answer.push(valTo)
                  : answer.push(JSON.parse(valTo));
              }
            });
          }
          let childrenData = {
            answer: answer,
            topicId: val.id,
            relationId: this.paperUuid,
            topicType: this.$route.query.title,
          };
          currentAnswer.push(childrenData);
        });
        params = {
          children: currentAnswer,
          topicId: currentQuestion.id,
          relationId: this.paperUuid,
          topicType: this.$route.query.title,
        };
      } else {
        let currentAnswer = this.parseAnswer(currentQuestion);
        if (currentQuestion.questionType === "简答题样式") {
          if (currentAnswer[0].name === null) {
            currentAnswer = [];
          }
        }
        params = {
          answer: currentAnswer,
          topicId: currentQuestion.id,
          relationId: this.paperUuid,
          topicType: this.$route.query.title,
        };
      }
      await topicNext(params);
    },
    /**
     * 更新答题卡状态和datas当前题目答案
     */
    answerChange() {
      const currentAnswer = this.parseAnswer(this.currentQuestion);
      this.answerSheetGroupDTOS.forEach((val) => {
        if (this.currentQuestion.questionType === "一题多问样式") {
          this.currentQuestion.topicList.forEach(valList => {
            val.children.forEach(val => {
              if(val.id === valList.id) {
                if(valList.questionType === "填空题样式" ||  valList.questionType === "简答题样式") {
                  val.topicStatus = valList.studentAnswerList[0].name? "haveDone" : "notDone"
                }else {
                  val.topicStatus = valList.studentAnswerList.length > 0? "haveDone" : "notDone"
                }
              }
            })
          })
          return;
        }
        val.children.forEach(valTo => {
          if(valTo.id === this.currentQuestion.id) {
            if(this.currentQuestion.questionType === '简答题样式') {
              valTo.topicStatus = currentAnswer[0].name? "haveDone" : "notDone"
            }else {
              valTo.topicStatus = currentAnswer && currentAnswer.length > 0 ? "haveDone" : "notDone"
            }
          }
        });
      });
    },
    /**
     * 将答案解析后传给后台
     */
    parseAnswer(currentQuestion) {
      let isNoDone = false;
      if (
        currentQuestion.questionType !== "单选题样式" &&
        currentQuestion.questionType !== "多选题样式" &&
        currentQuestion.questionType !== "判断题样式" &&
        currentQuestion.questionType !== "阅读判断题样式"
      ) {
        isNoDone = currentQuestion.studentAnswerList.every((item) => {
          return item.name === "";
        });
      }
      return currentQuestion.questionType !== "单选题样式" &&
        currentQuestion.questionType !== "多选题样式" &&
        currentQuestion.questionType !== "判断题样式" &&
        currentQuestion.questionType !== "阅读判断题样式"
        ? isNoDone
          ? []
          : currentQuestion.studentAnswerList
        : currentQuestion.studentAnswerList.map((item) => {
            return JSON.parse(item);
          });
    },
    /**
     * 点击答题卡到当前题
     */
    async jumpTo(pageNum, topNum, id) {
      this.showAnalysis = false;
      await this.putSaveAnswer();
      this.answerChange();
      this.resetCurrent(pageNum - 1, topNum, id);
    },
    /**
     * 简答题图片上传
     */
    // uploadChange(res) {
    //   this.currentQuestion.studentAnswerList[0].path = res;
    // },
    /**
     * 提交
     */
    async submit() {
      await this.putSaveAnswer();
      await this.saveAnswerSubmit();
      this.answerChange();
    },
    async saveAnswerSubmit() {
      const params = {
        relationId: this.paperUuid,
        topicType: this.$route.query.title,
      };
      const datas = await topicSubmit(params);
      if (datas) {
        this.scoreDialog = {
          title: "本次练习得分！",
          score: datas.studentScore,
          icon: "success",
          showCancelBtn: false,
        };

        this.isScoreVisible = true;
      }
    },
    /**
     * 更新datas的当前题收藏状态
     */
    updateCollect(val) {
      this.datas.topicList[this.currentIndex - 1].isCollect = val;
    },
    /**
     * 查看解析
     */
    scoreConfirm() {
      // this.$router.go(-2);
      this.$router.replace({
        name: "practiceAnalysis",
        query: {
          courseUuid: this.$route.query.paperUuid,
          topicType: this.$route.query.title,
          isDone: false,
          isShowDetail: true,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
</style>
<style lang="scss" scoped>
.uni-startPractice {
  display: flex;
  min-height: inherit;

  .iconfanhui {
    color: #999999;
    font-size: 38px;
    &:hover {
      color: #666666;
    }
  }
  .spanColor {
    color: #666666;
    font-size: 14px;
  }
  .leftBox {
    background-color: #ffffff;
    height: $contentH;
    flex: 1;
    padding: 20px 40px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 20px;
    &::-webkit-scrollbar {
      @include uni-hidden;
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .clear {
      margin: 65px 60px 0 60px;
      height: 1px;
      border: 1px dashed #e8e8e8;
    }
    .speed {
      padding-bottom: 52px;
      border-bottom: 1px dashed #e8e8e8;
      .text {
        color: #9a9a9a;
        font-size: 14px;
        margin: 30px 0 20px 0;
      }
      .strip {
        display: flex;
        align-items: center;
        .box {
          flex: 1;
        }
        .textBox {
          margin-left: 32px;
          span {
            font-size: 14px;
            color: #9a9a9a;
            &:first-child {
              color: #f38829;
            }
          }
          em {
            font-style: normal;
            margin: 0 10px;
            color: #9a9a9a;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
</style>
